<template>
    <div>
        <h2>Údaje o stavbě</h2>
        <ssv-order-building-certification-form ref="buildingCertificationForm"/>
    </div>
</template>

<script>
    import SsvOrderBuildingCertificationForm from './BuildingCertificationForm';

    export default {
        name: 'SsvOrderBuildingCertificationContainer',
        components: {
            SsvOrderBuildingCertificationForm
        },
        methods: {
            validate() {
                this.$refs.buildingCertificationForm.validate();
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/ssv-order/building-certification/BuildingCertificationContainer.vue